type WindowLocation = Pick<Location, "origin" | "href" | "pathname" | "search">

export const getLocation = (): WindowLocation => ({
  origin: window.location.origin,
  href: window.location.href,
  pathname: window.location.pathname,
  search: window.location.search,
})

export const redirectTo = (url: string, replace = false) => {
  if (replace) {
    window.location.replace(url)
  } else {
    window.location.href = url
  }
}
